import { IChatWidgetState } from '../types';
import reducerFactory, { IAction } from '../../reducer-factory';
import * as actionNames from './actions/names';
import * as types from './actions/types';

export const ChatWidgetReducerHandler = {
  [actionNames.SET_STATUS]: (
    state: IChatWidgetState,
    action: types.SetStatus,
  ): IChatWidgetState => ({
    ...state,
    status: action.value,
  }),
  [actionNames.SET_IS_WINDOW_OPEN]: (
    state: IChatWidgetState,
    action: types.SetIsWindowOpen,
  ): IChatWidgetState => ({
    ...state,
    isWindowOpen: action.value,
  }),
  [actionNames.SET_ERROR]: (state: IChatWidgetState, action: types.SetError): IChatWidgetState => ({
    ...state,
    error: action.value,
  }),
  [actionNames.SET_IS_LEGAL_ACCEPTED]: (
    state: IChatWidgetState,
    action: types.SetIsLegalAccepted,
  ): IChatWidgetState => ({
    ...state,
    isLegalAccepted: action.value,
  }),
  [actionNames.SET_DEVICE_TYPE]: (
    state: IChatWidgetState,
    action: types.SetDeviceType,
  ): IChatWidgetState => ({
    ...state,
    deviceType: action.value,
  }),
  [actionNames.SET_IS_AGENTS_AVAILABLE]: (
    state: IChatWidgetState,
    action: types.SetIsAgentsAvailable,
  ): IChatWidgetState => ({
    ...state,
    isAgentsAvailable: action.value,
  }),
  [actionNames.SET_FLOATING_BUTTONS_HIDDEN]: (
    state: IChatWidgetState,
    action: types.SetFloatingButtonsHidden,
  ): IChatWidgetState => ({
    ...state,
    areFloatingButtonsHidden: action.value,
  }),
};

const chatWidgetReducer = (state: IChatWidgetState, action: IAction): IChatWidgetState =>
  reducerFactory(state, action, ChatWidgetReducerHandler);

export default chatWidgetReducer;
